import { render, staticRenderFns } from "./CarUpTxtDownImg.vue?vue&type=template&id=08f7358a&scoped=true"
import script from "./CarUpTxtDownImg.vue?vue&type=script&lang=js"
export * from "./CarUpTxtDownImg.vue?vue&type=script&lang=js"
import style0 from "./CarUpTxtDownImg.vue?vue&type=style&index=0&id=08f7358a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7358a",
  null
  
)

export default component.exports